
import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { EyeOff, UserCircle } from "lucide-react";

export const ImpersonationBar: React.FC = () => {
  const { user, isImpersonating, stopImpersonating, originalUser } = useAuth();
  
  if (!isImpersonating || !user) {
    return null;
  }
  
  return (
    <div className="bg-yellow-100 text-yellow-800 py-2 px-4 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <UserCircle className="h-5 w-5" />
        <span className="text-sm font-medium">
          You are impersonating {user.email}
        </span>
      </div>
      <Button 
        variant="outline"
        size="sm"
        className="border-yellow-400 bg-yellow-50 hover:bg-yellow-200 text-yellow-800"
        onClick={() => stopImpersonating()}
      >
        <EyeOff className="mr-2 h-4 w-4" />
        Exit Impersonation
      </Button>
    </div>
  );
};
